"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.futuresPositionsReducer = void 0;
var actions = _interopRequireWildcard(require("../actions"));
var _immer = require("immer");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var initialState = {
  openPositions: [],
  positionHistory: [],
  // Maybe needed later below
  // repaymentAssetOptions: [],
  isLoadingOpenPositions: false,
  isLoadingPositionHistory: false
};
var futuresPositionsReducer = exports.futuresPositionsReducer = (0, _immer.produce)(function (draft, _ref) {
  var type = _ref.type,
    payload = _ref.payload;
  switch (type) {
    case actions.REQUEST_OPEN_POSITIONS:
      draft.isLoadingOpenPositions = true;
      break;
    case actions.RECEIVE_OPEN_POSITIONS:
      draft.isLoadingOpenPositions = false;
      draft.openPositions = payload;
      break;
    case actions.REQUEST_POSITION_HISTORY:
      draft.isLoadingPositionHistory = true;
      break;
    case actions.RECEIVE_POSITION_HISTORY:
      draft.isLoadingPositionHistory = false;
      draft.positionHistory = payload;
      break;

    // Might be needed later
    // case actions.RECEIVE_REPAYMENT_ASSET_OPTIONS:
    //   draft.activeRequests--;
    //   draft.repaymentAssetOptions = payload;
    //   break;

    case actions.UPDATE_FUTURES_POSITION:
      {
        var positionIndex = draft.openPositions.findIndex(function (position) {
          return position.PositionId === payload.PositionId;
        });
        if (positionIndex !== -1) {
          if (payload.PositionState === 'Closed') {
            // Remove closed position
            draft.openPositions.splice(positionIndex, 1);
            draft.positionHistory.push(payload);
          } else {
            // Update existing position
            Object.assign(draft.openPositions[positionIndex], payload);
          }
        } else if (payload.PositionState === 'Open' && payload.ChangeReason === 'Opened') {
          // Add new position
          draft.openPositions.push(payload);
        }
        break;
      }
  }
}, initialState);